import BalanceRow from '@components/BalanceRow'
import useConfig from '@plug-core/hooks/useConfig'
import { PerpPosition } from '@plug-core/interfaces/hyperliquid'
import { formatMoney } from '@plug-core/utils/formatNumber'
import { ROUTES } from '@utils/routes'
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

interface PerpBalanceRowProps {
  position: PerpPosition
}

const PerpBalanceRow: FC<PerpBalanceRowProps> = ({ position: { position } }) => {
  const { perpsTokens, tokens } = useConfig()
  const perpToken = perpsTokens.find((t) => t.name === position.coin)
  const token = tokens.find((t) => t.additionalData.hyperliquidId === perpToken?.id.toString())

  const navigate = useNavigate()

  const size = Math.abs(parseFloat(position.szi))
  const entryPx = parseFloat(position.entryPx)
  const pnl = parseFloat(position.unrealizedPnl)

  const notional = size * entryPx
  const pnlPct = (pnl / notional) * 100

  return (
    <BalanceRow
      logo={token?.logo}
      title={`${position.coin}-USD`}
      subtitle={`${parseFloat(position.szi) > 0 ? 'Long' : 'Short'} ${position.leverage.value}x`}
      value={formatMoney(parseFloat(position.marginUsed))}
      valueChange={pnlPct}
      onPress={() => navigate(ROUTES.PERP_DETAILS(perpToken?.id?.toString() || ''))}
    />
  )
}

export default PerpBalanceRow
